import qs from 'qs';
import { network } from 'services/network';

export const setSubProgramPreferenceImportance = ({
    projectId,
    subProgramId,
    topCriticalityPercent,
    completionPercent,
    isNeedRefresh,
}) => {
    const querystring = qs.stringify(
        { projectId, subProgramId, topCriticalityPercent, completionPercent, isNeedRefresh },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/setSubProgramPreferenceImportance${querystring}`;

    return network.post(url).then((response) => response.data);
};
